import React, { FC } from 'react'
import { StatusProps } from './Status-types'
import { statusStyles } from './Status-styles'
import { cn } from 'ethcss'
import { colors } from '../../theme'
import translate from '../../core/translate'
import { Tooltip } from '../../atoms/Tooltip'

const styles = {
    4: {
        width: '26%',
        borderWidth: '4px',
    },
    6: {
        width: 32,
        borderWidth: 2,
        height: 25,
    },
    8: {
        width: 25,
        height: 20,
        borderWidth: 2,
    },
}

const Status: FC<StatusProps> = ({ status, children, disable, className, isList, tileCount }) => {
    const statusStyle = statusStyles.status + tileCount

    return (
        <div
            className={cn(
                className,
                statusStyles.status,
                { [statusStyles.disable]: disable },
                isList ? statusStyles.statusList : ''
            )}
            style={{
                borderColor: colors[status ? status : 'offline'],
                //...styles[tileCount || 4]
            }}
        >
            <div className={statusStyles.main}>
                <Tooltip isEnabled={true} title={translate(status || '')} position="right">
                    <div className={statusStyles.statusText}>{children}</div>
                </Tooltip>
            </div>
        </div>
    )
}

export { Status }
